module.exports = __webpack_public_path__ + "img/DSC_0283-compressor_tn.21db9e29.jpg";